import React, {
	Component
} from 'react';
import { store } from '../stores/mainStore';

import styled from 'styled-components';
import { observer } from 'mobx-react';
import { comm } from "../comm";
// import { RotationMessage } from './RotationMessage';

//import {debounce} from 'lodash';
import { Loader } from './Loader';
import { B64Image } from './B64Image';

const GameGroup = styled.div`
	display: flex;
	width: 100vw;
	height: 100vh;
	flex-direction: column;
`
const Background = styled.div`
	height: 100%;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center center;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
`
@observer
export class Game extends Component {
	constructor(props){
		super(props);
		store.setSpinner(true);
		this.launchMatch(props)
		store.topBar.hide = true;
		store.showBottomNav = false;
	}

	launchMatch = (props) => {
		const matchId = parseInt(props.match.params.gameId, 10);
		if(store.activeMatch === null){
			store.processNotifications = false;
			console.log(matchId);
			if(props.match.params.gameId === 'tutorial' || props.match.params.gameId === 'intro'){
				store.tutorialMode = true;
				store.startMatchFromId(props.match.params.gameId, 'play')
				.then(() => {
					manager.startGame();
				});
			} else {
				store.tutorialMode = false; //ensure that a real game can't be stuck in tutorial mode.
				store.startMatchFromId(matchId, props.match.params.mode)
				.then(() => {
					manager.startGame();
				});
			}
		} else {
			setTimeout(this.launchMatch.bind(this,props), 150);
		}
		//clear nudge notifications
		var nudgeNotification = store.nudges.find(n => n.Data.MatchId === matchId.toString());
		if(nudgeNotification){
			comm.ConfirmNotification(nudgeNotification.ConfirmationKey)
			.then(() => {
				store.nudges.remove(nudgeNotification);
			})
		}
	}

	componentDidUpdate(prevProps){
		if(prevProps.match.params.gameId !== this.props.match.params.gameId){
			Promise.all([
				manager.resetToWaiting(),
				store.startMatchFromId(parseInt(this.props.match.params.gameId,10), this.props.match.params.mode)
			])
			.then(() => {
				manager.startGame();
			});
		}
	}

	componentWillUnmount(){
		manager.resetToWaiting()
		.then(() => {
			window.setPersistentStorage('gameInProgress', '');
			store.activeMatch = null;
			store.processNotifications = true;
		})
	}

	state = {
		// dimensions: this.calculateAspectRatioFit(852, 480, window.innerWidth, window.innerHeight),
		dimensions: {},
		requestRotation: false
	}

	render() {

		return (
			<GameGroup>
				<Background/>
				{!store.phaserLoading && (
					<Loader>
						<B64Image draggable="false" alt="" key="preload-faq" src="/assets/R7 Help Guide - FINAL.jpg"/>
						<B64Image draggable="false" alt="" key="preload-heart" src="/assets/heart_box.jpg"/>
						<B64Image draggable="false" alt="" key="preload-ring" src="/assets/portrait_ring.png"/>
						{/* <B64Image draggable="false" alt="" key="preload-exit" src="/assets/exit_message.png"/> */}
						<B64Image draggable="false" alt="" key="preload-image" src={store.user.image}/>
					</Loader>
				)}
			</GameGroup>
		);
	}
}
